import { Injectable } from '@angular/core';
import advantageOne from '!!file-loader!../images/advantage-1.png';
import advantageTwo from '!!file-loader!../images/advantage-2.png';
import advantageThree from '!!file-loader!../images/advantage-3.png';
import advantageFour from '!!file-loader!../images/advantage-4.png';
import advantageFive from '!!file-loader!../images/advantage-5.png';
import { Discount } from '../../../constants/discount.constants';

@Injectable()
export class AdvantageDatasourceService {
  advantages = [
    {
      image: advantageOne,
      title: `1900 анализов со скидкой до ${Discount.Amount}${Discount.UnitMeasurement}`,
      description:
        'Почти все процессы мы перевели в онлайн, а значит – можем предложить хорошие скидки',
    },
    {
      image: advantageTwo,
      title: 'Высокие стандарты лабораторной диагностики',
      description:
        'Анализы выполняются в Лабораторных комплексах Хеликс по международным стандартам качества',
    },
    {
      image: advantageThree,
      title: 'Без лишних действий и бумаг',
      description:
        'Все заказы, договоры и результаты анализов – в удобном мобильном приложении',
    },
    {
      image: advantageFour,
      title: 'Минимум контактов',
      description:
        'Оформляйте и оплачивайте заказы онлайн – без взаимодействия <br> с административным персоналом',
    },
    {
      image: advantageFive,
      title: 'С заботой о вашем комфорте',
      description: `Оптимально для тех, кто ценит конфиденциальность и личное пространство. Вся информация о заказе – только в
    вашем смартфоне`,
    },
  ];
}
